module.exports = __webpack_public_path__ + "static/img/kefu_btn.ae043a60.png";